(function () {
  'use strict';

  function loadRecommendations(el) {
    if (!el || el.dataset.relatedLoaded === 'true') return;
    var url = el.dataset.url;
    if (!url) return;

    el.dataset.relatedLoaded = 'true';

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = document.createElement('div');
        doc.innerHTML = text;
        var incoming = doc.querySelector('[data-related-products]');
        if (!incoming || !incoming.innerHTML.trim()) {
          el.remove();
          return;
        }
        el.innerHTML = incoming.innerHTML;

        document.querySelectorAll('[data-bb-product-row]').forEach(function (row) {
          if (row.dataset.bbProductRowReady === 'true') return;
          if (typeof window.bbInitProductRow === 'function') {
            window.bbInitProductRow(row);
          }
        });
      })
      .catch(function () {
        el.removeAttribute('data-related-loaded');
      });
  }

  function observe(el) {
    if (!('IntersectionObserver' in window)) {
      loadRecommendations(el);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        obs.unobserve(el);
        loadRecommendations(el);
      },
      { rootMargin: '0px 0px 200px 0px' }
    );

    observer.observe(el);
  }

  document.querySelectorAll('[data-related-products]').forEach(observe);
})();
